import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './components/Header';
import Footer from './components/Footer';
import LionVoicePage from './pages/LionVoicePage';
import LionVoiceEpisodePage from './pages/LionVoiceEpisodePage';
import LoginPage from './pages/LoginPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import NotFoundPage from './pages/NotFoundPage';
import { authAPI } from './services/api';

const PORTAL_URL = 'https://portal.lionsclubs.org.hk';

function ProtectedRoute({ children }) {
  const isAuth = authAPI.isAuthenticated();

  useEffect(() => {
    if (!isAuth) {
      const next = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.replace(`${PORTAL_URL}?next=${next}`);
    }
  }, [isAuth]);

  if (!isAuth) return null;
  return children;
}

function App() {
  return (
    <Routes>
      {/* Admin local login */}
      <Route path="/login" element={<LoginPage />} />
      {/* SSO callback from membership portal */}
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="*" element={
        <ProtectedRoute>
          <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header />
            <Box component="main" sx={{ flexGrow: 1 }}>
              <Routes>
                <Route path="/" element={<LionVoicePage />} />
                <Route path="/episodes/:id" element={<LionVoiceEpisodePage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Box>
            <Footer />
          </Box>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

export default App;
